import { useContext, useEffect, useState } from "react";
import { HubCtx } from "@/components/AppShell";
import { Delete, LockKeyhole } from "lucide-react";

const CYAN = "var(--glow-family)";

// 6-digit pad: on-screen keys (56px+) and the keyboard both work.
export default function CodePad({ title, hint, error, busy, onSubmit, footer, testid = "vault-pad" }) {
  const [code, setCode] = useState("");
  const demoCode = useContext(HubCtx)?.hub?.demo?.vault_code;
  const push = (k) => setCode((c) => (k === "del" ? c.slice(0, -1) : c.length < 6 ? c + k : c));
  useEffect(() => {
    const on = (e) => { if (/^\d$/.test(e.key)) push(e.key); else if (e.key === "Backspace") push("del"); };
    window.addEventListener("keydown", on);
    return () => window.removeEventListener("keydown", on);
  }, []);
  useEffect(() => {
    if (code.length === 6 && !busy) { const c = code; setCode(""); onSubmit(c); }
  }, [code, busy, onSubmit]);
  return (
    <div className="mx-auto max-w-sm text-center" data-testid={testid}>
      <span className="mx-auto mb-3 inline-flex h-14 w-14 items-center justify-center rounded-2xl" style={{ background: `rgba(${CYAN},0.14)` }}><LockKeyhole className="h-7 w-7" style={{ color: `rgb(${CYAN})` }} /></span>
      <h2 className="font-display text-2xl font-extrabold text-q-text" data-testid={`${testid}-title`}>{title}</h2>
      {hint && <p className="mt-1 text-sm text-q-muted">{hint}</p>}
      <div className="my-5 flex justify-center gap-3" aria-label={`${code.length} of 6 digits`} data-testid={`${testid}-dots`}>
        {Array.from({ length: 6 }, (_, i) => <span key={i} className="h-4 w-4 rounded-full border-2 transition-colors duration-150" style={{ borderColor: `rgb(${CYAN})`, background: i < code.length ? `rgb(${CYAN})` : "transparent" }} />)}
      </div>
      {error && <p className="q-error mb-3" role="alert" data-testid={`${testid}-error`}>{error}</p>}
      <div className="mx-auto grid max-w-[264px] grid-cols-3 gap-3">
        {["1", "2", "3", "4", "5", "6", "7", "8", "9", "", "0", "del"].map((k) => (k === "" ? <span key="blank" /> : (
          <button key={k} disabled={busy} onClick={() => push(k)} aria-label={k === "del" ? "Delete digit" : k}
            className="flex h-16 min-h-[56px] w-full min-w-[56px] items-center justify-center rounded-2xl border border-q-line bg-q-raised font-display text-2xl font-bold text-q-text transition-transform duration-100 active:scale-95"
            data-testid={`${testid}-key-${k}`}>{k === "del" ? <Delete className="h-6 w-6" /> : k}</button>
        )))}
      </div>
      {demoCode && <p className="mt-3 text-sm font-semibold text-q-muted" data-testid={`${testid}-demo-code`}>Demo vault code: {demoCode}</p>}
      {footer}
    </div>
  );
}
